import route from 'ziggy-js';
import {
    Ziggy
} from '@/ziggy';

if (!$env.locale.default && $env.locale.current) {
    Ziggy.url = Ziggy.url + '/' + $env.locale.current;
}

export default (name, params, absolute, config = Ziggy) => route(name, params, absolute, config)